// extracted by mini-css-extract-plugin
export default {"menu":"applications-components-HeaderApp-components-SidebarPane-sidebar-pane-module__menu","pane":"applications-components-HeaderApp-components-SidebarPane-sidebar-pane-module__pane","container":"applications-components-HeaderApp-components-SidebarPane-sidebar-pane-module__container"};
    if(module.hot) {
      // 1782397803613
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  